import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';

import Text from '../../../Text';

import { DynamicContainer } from '../../../Layout/DynamicContainer';

import { HoverConsumer } from '../../../../custom-cursor';

import clutchRating from '../../../../../../static/images/about-us/clutch-rating.svg';

const TestimonialLastSlide = ({ styles, rules, context, setContext }) => {
    const intl = useIntl();
    const { formatMessage } = intl;
    const altMessage = formatMessage({ id: 'aboutUsPage.testimonials.lastSlide.clutchRating' });

    const handleLeave = () => {
        setContext({
            ...context,
            carousel: {
                ...context.carousel,
                titleHovered: false,
            },
        });
    };

    const handleEnter = () => {
        setContext({
            ...context,
            carousel: {
                ...context.carousel,
                titleHovered: true,
                titleMessageId: 'aboutUsPage.testimonials.lastSlide.tooltip',
            },
        });
    };

    return (
        <div className={styles.container}>
            <DynamicContainer extend={rules.extendContainer} isFluid>
                <a
                    href="https://clutch.co/profile/ackee?page=0%2C1"
                    onMouseEnter={handleEnter}
                    onMouseLeave={handleLeave}
                    className={styles.link}
                >
                    <Text extend={{ text: rules.text }}>
                        <FormattedMessage id="aboutUsPage.testimonials.lastSlide.readMore" />
                    </Text>
                    <img src={clutchRating} className={styles.image} alt={altMessage} />
                </a>
            </DynamicContainer>
        </div>
    );
};

TestimonialLastSlide.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,

    context: PropTypes.shape().isRequired,
    setContext: PropTypes.func.isRequired,
};

const CaseStudyWrapper = props => (
    <HoverConsumer>
        {render => <TestimonialLastSlide context={render.context} setContext={render.setContext} {...props} />}
    </HoverConsumer>
);

export default CaseStudyWrapper;
